// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3258d17a","239":"2b32b656","455":"fa6488e5"}[chunkId] + ".chunk.js";
};